// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Q0qlY","image":"Header_image__3v2-c","name":"Header_name__1pdDa","info":"Header_info__1MKW8","infoRow":"Header_infoRow__257SR"};